import { PaginationControls } from './PaginationControls'
import { Box, Stack, Typography } from '@mui/material'

export type ActionDrawerActiveItemDescriptionProps = {
    title: string
    subtitle: string
    extraIcons?: JSX.Element | null
    descriptionList: { term: string; detail: string }[]
}

export const ActionDrawerActiveItemDescription = ({
    title,
    subtitle,
    descriptionList,
    extraIcons,
}: ActionDrawerActiveItemDescriptionProps) => {
    return (
        <Stack>
            <Stack direction="row" gap={2} alignItems="center" sx={{ mr: -1 }}>
                <Typography variant="body1" fontWeight={600} textTransform="uppercase" flex={1}>
                    {title}
                </Typography>
                <PaginationControls />
            </Stack>
            <Stack
                direction="row"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Box sx={{ color: '#444' }}>
                    <Typography variant="body1" fontWeight={400} sx={{ color: '#444' }}>
                        {subtitle}
                    </Typography>
                    <Box sx={{ fontSize: 13 }}>
                        {descriptionList.map(({ term, detail }) => (
                            <Stack direction="row" gap={0.5} key={term}>
                                <Typography variant="body1" fontSize={13} fontWeight={500}>
                                    {term}:
                                </Typography>

                                <Typography variant="body1" fontSize={13} fontWeight={300}>
                                    {detail}
                                </Typography>
                            </Stack>
                        ))}
                    </Box>
                </Box>
                {extraIcons && <Box>{extraIcons}</Box>}
            </Stack>
        </Stack>
    )
}
